import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=2b196024&scoped=true&"
import script from "./tips.vue?vue&type=script&lang=js&"
export * from "./tips.vue?vue&type=script&lang=js&"
import style0 from "./tips.vue?vue&type=style&index=0&id=2b196024&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b196024",
  null
  
)

export default component.exports